var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable security/detect-object-injection */
import colorMap from './colors';
import { LogLevel, } from '../types';
var WHISPER_LOG_SILENT = process.env && process.env.WHISPER_LOG_SILENT;
var WHISPER_LOG_NAMESPACES = (process.env && process.env.WHISPER_LOG_NAMESPACES) || '';
var noop = function () {
    /* noop */
};
export var isLevel = function (level) {
    return Object.prototype.hasOwnProperty.call(LogLevel, level);
};
export var getLogLevel = function (level) {
    if (level === void 0) { level = ''; }
    if (level && isLevel(level)) {
        return LogLevel[level];
    }
    return LogLevel.info;
};
export var logLevelLocalstorageKey = 'WHISPER_LOG_LEVEL';
export var getLocalStorageLogLevel = function (typeOfWindow) {
    if (typeOfWindow === void 0) { typeOfWindow = typeof window; }
    if (typeOfWindow !== 'undefined' && window.localStorage) {
        var storedLogLevel = window.localStorage.getItem(logLevelLocalstorageKey);
        return storedLogLevel && isLevel(storedLogLevel)
            ? LogLevel[storedLogLevel]
            : null;
    }
    return null;
};
var isSilenced = WHISPER_LOG_SILENT === 'TRUE';
var envNameSpaces = WHISPER_LOG_NAMESPACES.split(',').filter(Boolean);
export var getConfigDefaults = function (config, typeOfWindow) {
    if (typeOfWindow === void 0) { typeOfWindow = typeof window; }
    if (typeOfWindow !== 'undefined') {
        return __assign({ 
            // eslint-disable-next-line
            output: function () {
                var _a;
                var message = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    message[_i] = arguments[_i];
                }
                return (_a = window.console).log.apply(_a, message);
            } }, config);
    }
    return __assign({ 
        // eslint-disable-next-line no-console
        output: (console && console.log) || noop }, config);
};
// Given a level of a logger function and a "desiredLevel" that is the cut off
// point for if a log is made or not, return a boolean that indicates if the
// logger should log.
export var shouldLogForLevel = function (_a) {
    var level = _a.level, desiredLevel = _a.desiredLevel, localStorageLogLevel = _a.localStorageLogLevel;
    // The level of the particular LogFunc
    var logLevel = getLogLevel(level);
    // The level the whisper logger was created with.
    var initLevel = desiredLevel && LogLevel[desiredLevel];
    // The environment log level set when we were last in node.
    var envLogLevel = getLogLevel(process.env.WHISPER_LOG_LEVEL);
    // Prefer explicit initialization level over environment level.
    var desiredLogLevel = (initLevel !== null && initLevel !== void 0 ? initLevel : envLogLevel);
    return localStorageLogLevel !== null
        ? logLevel <= localStorageLogLevel
        : logLevel <= desiredLogLevel;
};
var joinLevelAndMessage = function (_a) {
    var level = _a.level, message = _a.message;
    return level + "-" + message;
};
// This is the function that actually creates the `log` method on the object
// returned from `createLogger` function. It stores configuration given to
// `createLogger` and combines it with call time options before invoking the
// `formatter` and `outPut` functions.
var log = function (config) {
    var _a = getConfigDefaults(config), defaultOutput = _a.output, desiredLevel = _a.level, environment = _a.environment, formatter = _a.formatter, nameSpace = _a.nameSpace;
    var localStorageLogLevel = getLocalStorageLogLevel();
    var previouslyCalled = [];
    return function (calltimeOpts) {
        if (isSilenced || config.silent)
            return;
        var level = calltimeOpts.level, color = calltimeOpts.color, message = calltimeOpts.message, once = calltimeOpts.once, _a = calltimeOpts.output, output = _a === void 0 ? defaultOutput : _a, loggerOpts = __rest(calltimeOpts, ["level", "color", "message", "once", "output"]);
        if (once && previouslyCalled.includes(joinLevelAndMessage(calltimeOpts))) {
            return;
        }
        var namespaceInclusive = envNameSpaces.length > 0 ? envNameSpaces.includes(nameSpace) : true;
        var levelSufficient = shouldLogForLevel({
            level: level,
            desiredLevel: desiredLevel,
            localStorageLogLevel: localStorageLogLevel,
        });
        var shouldLog = levelSufficient && namespaceInclusive;
        if (shouldLog) {
            var safeColor = color || colorMap[getLogLevel(level)][environment];
            var logMessage = formatter(__assign(__assign(__assign({ nameSpace: nameSpace,
                message: message, color: safeColor }, config), loggerOpts), { level: level }));
            if (once) {
                previouslyCalled.push(joinLevelAndMessage(calltimeOpts));
            }
            if (Array.isArray(logMessage)) {
                output.apply(void 0, logMessage);
                return;
            }
            output(logMessage);
        }
    };
};
export default log;
//# sourceMappingURL=log.js.map